export default __webpack_public_path__ + "static/InterDisplay-ExtraBoldItalic-cd486a166612d67849a04418de14fb38.woff";